var React = require('react');

function ArrowWhite (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M38.3216 8.9882C38.7447 8.56513 38.7447 7.8792 38.3216 7.45614L31.4273 0.561845C31.0042 0.138777 30.3183 0.138777 29.8952 0.561845C29.4722 0.984913 29.4722 1.67084 29.8952 2.09391L36.0235 8.22217L29.8952 14.3504C29.4722 14.7735 29.4722 15.4594 29.8952 15.8825C30.3183 16.3056 31.0042 16.3056 31.4273 15.8825L38.3216 8.9882ZM0 9.3055H37.5556V7.13883H0V9.3055Z","fill":"#ffffff"}));
}

ArrowWhite.defaultProps = {"width":"39","height":"17","viewBox":"0 0 39 17","fill":"none"};

module.exports = ArrowWhite;

ArrowWhite.default = ArrowWhite;
